module.exports = __webpack_public_path__ + "static/media/sentakumonoHoshi.148cb83c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/training_thumbnails/adl/sentakumonoHoshi.png
// module id = 1699
// module chunks = 1